import { render } from "./TasksList.vue?vue&type=template&id=53d535c0&scoped=true"
import script from "./TasksList.vue?vue&type=script&lang=js"
export * from "./TasksList.vue?vue&type=script&lang=js"

import "./TasksList.vue?vue&type=style&index=0&id=53d535c0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-53d535c0"

export default script